import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import { I18nProvider } from './context/I18nContext';
import App, { preloadRoute } from './App';
import { initErrorReporting } from './utils/errorReporting';
import 'react-toastify/dist/ReactToastify.css';
// After the toastify styles, matching the order the Tailwind CDN used to give.
import './tailwind.css';

initErrorReporting();

const app = (
  <React.StrictMode>
    <Provider store={store}>
      <I18nProvider>
        <App />
      </I18nProvider>
    </Provider>
  </React.StrictMode>
);

// Marketing pages ship prerendered HTML (scripts/prerender.js). Load the
// route's code first, so React's first commit swaps the static markup for the
// identical live page instead of flashing the loading screen in between.
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
const ready = container.hasChildNodes()
  ? preloadRoute(window.location.pathname).catch(() => {})
  : Promise.resolve();
ready.then(() => root.render(app));
